import { Grid, Slider, Typography } from "@material-ui/core";
import { FastForward, PlayArrow, Pause } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import useInterval from "components/Utils/UseInterval";
interface ShiftPlaybackSliderProps {
  firstLocationTime: number;
  lastLocationTime: number;
  onNewTime: (time: number) => void;
  findFirstIndexes: (time: number) => Promise<boolean>;
}

interface ShiftPlaybackSliderState {
  playbackTime: string;
  step: number;
  min: number;
  max: number;
  rangeValue: number;
  playing: boolean;
}

const DEFAULT_STATE: ShiftPlaybackSliderState = {
  playbackTime: "--:--:--",
  step: 5000,
  min: 0,
  max: 100,
  rangeValue: 10,
  playing: false,
};
export default function ShiftPlaybackSlider(props: ShiftPlaybackSliderProps) {
  const [state, setState] = useState<ShiftPlaybackSliderState>(DEFAULT_STATE);
  const playButton = state.playing ? (
    <Pause
      onClick={() => {
        handlePlayClicked();
      }}
    />
  ) : (
    <PlayArrow
      onClick={() => {
        handlePlayClicked();
      }}
    />
  );
  const playSpeedButton = <FastForward />;

  const handlePlayClicked = async () => {
    await props.findFirstIndexes(state.rangeValue);
    setState((prevState) => ({ ...state, playing: !prevState.playing }));
  };

  useInterval(() => {
    if (state.playing) {
      props.onNewTime(state.rangeValue + state.step);
      setState((prevState) => ({
        ...prevState,
        rangeValue: prevState.rangeValue + state.step,
      }));
    }
  }, 1000);
  const handleTimeChange = async (event: any, newValue: any) => {
    setState({ ...state, playing: false, rangeValue: newValue });
    await props.findFirstIndexes(newValue);
  };

  useEffect(() => {
    setState({
      ...state,
      min: props.firstLocationTime,
      max: props.lastLocationTime,
      rangeValue: props.firstLocationTime,
    });
  }, [props.firstLocationTime]);
  let playbackTime = "--:--:--";
  if (state.rangeValue === 10) {
    playbackTime = "--:--:--";
  } else {
    const currentDateObject = new Date(state.rangeValue);
    const arrayIzzle = currentDateObject.toISOString().split("T");
    const izzle = arrayIzzle[1];
    const izzleArray = izzle.split(".");
    playbackTime = izzleArray[0];
  }
  return (
    <Grid container spacing={2}>
      <Grid item>{playButton}</Grid>
      <Grid item>
        <Typography>{playbackTime}</Typography>
      </Grid>
      <Grid item xs>
        <Slider
          defaultValue={1}
          value={state.rangeValue}
          aria-labelledby="discrete-slider-small-steps"
          step={state.step}
          onChange={handleTimeChange}
          min={state.min}
          max={state.max}
          valueLabelDisplay="off"
        />
      </Grid>
      <Grid item>{playSpeedButton}</Grid>
    </Grid>
  );
}
